import React from 'react';
import { useTranslation } from 'react-i18next';
import { checkFreePackage } from '@src/services/package';
import pluralize from '@src/utils/pluralize';
import Text from '../Shared/Text';
import CheckOrCross from '../Shared/CheckOrCross';

export const CostPerCharacterFeature = ({ pkg, featurePath }) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const costPerChar = pkg?.apiFeatures?.[featurePath]?.costPerCharacter;

  if (checkFreePackage(pkg?.code) || !costPerChar) {
    return <CheckOrCross key={pkg.code} isCheck={false} />;
  }

  const creditUnit = pluralize(costPerChar, t('credit'), language);

  return (
    <Text
      key={pkg.code}
      html={t('costPerCharacterUnit', { cost: costPerChar, creditUnit })}
    />
  );
};

export const ConcurrentCCRFeature = ({ pkg, ccr }) => {
  if (checkFreePackage(pkg?.code) || !ccr) {
    return <CheckOrCross key={pkg.code} isCheck={false} />;
  }

  return <Text key={pkg.code} text={String(ccr)} />;
};

export const PurchaseAdditionalCCRFeature = ({ pkg, featurePath }) => {
  const additionalCCR = pkg?.apiFeatures?.[featurePath]?.additionalCCR;

  if (checkFreePackage(pkg?.code) || !additionalCCR) {
    return <CheckOrCross key={pkg.code} isCheck={false} />;
  }

  return <Text key={pkg.code} text={additionalCCR} />;
};

export const CostPerSecondFeature = ({ pkg, featurePath }) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const costPerSecond = pkg?.apiFeatures?.[featurePath]?.costPerSecond;

  if (checkFreePackage(pkg?.code) || !costPerSecond) {
    return <CheckOrCross key={pkg.code} isCheck={false} />;
  }

  const creditUnit = pluralize(costPerSecond, t('credit'), language);

  return (
    <Text
      key={pkg.code}
      html={t('costPerSecondUnit', { cost: costPerSecond, creditUnit })}
    />
  );
};

export const CostPerBlock15sFeature = ({ pkg, featurePath }) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const costPerBlock = pkg?.apiFeatures?.[featurePath]?.costPerBlock15s;

  if (checkFreePackage(pkg?.code) || !costPerBlock) {
    return <CheckOrCross key={pkg.code} isCheck={false} />;
  }

  const creditUnit = pluralize(costPerBlock, t('credit'), language);

  return (
    <Text
      key={pkg.code}
      html={t('costPerBlock15sUnit', { cost: costPerBlock, creditUnit })}
    />
  );
};

export const CostPerCharFromFlagFeature = ({
  pkg,
  creditPerChar,
  featureName,
}) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const hasFeature = pkg?.features?.includes(featureName);

  if (checkFreePackage(pkg?.code) || !hasFeature || !creditPerChar) {
    return <CheckOrCross key={pkg.code} isCheck={false} />;
  }

  const creditUnit = pluralize(creditPerChar, t('credit'), language);

  return (
    <Text
      key={pkg.code}
      html={t('costPerCharacterUnit', {
        cost: creditPerChar.toLocaleString(language),
        creditUnit,
      })}
    />
  );
};

export const CostPerBlockFeature = ({ pkg, creditPerBlock, featureName }) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const hasFeature = pkg?.features?.includes(featureName);

  if (checkFreePackage(pkg?.code) || !hasFeature || !creditPerBlock) {
    return <CheckOrCross key={pkg.code} isCheck={false} />;
  }

  const creditUnit = pluralize(creditPerBlock, t('credit'), language);

  return (
    <Text
      key={pkg.code}
      html={t('costPerBlockUnit', {
        cost: creditPerBlock.toLocaleString(language),
        creditUnit,
      })}
    />
  );
};
